import styled from 'styled-components'

import Container from '../../atoms/Container'
import Row from '../../atoms/Row'
import Col from '../../atoms/Col'

import Main from '../Blank/Main'

const LandingPageMain = styled(Main)`
  @media (min-width: 768px) {
    ${Container} > ${Row} > ${Col} {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }

  @media (min-width: 992px) {
    ${Container} > ${Row} > ${Col} {
      flex: 0 0 66.67%;
      max-width: 66.67%;
    }
  }
`

export default LandingPageMain
